<template>
  <div>
    <el-dialog
      :visible.sync="addServiceDialog"
      width="50%"
      title="设备"
      :close-on-click-modal="false"
    >
      <el-form :model="form" label-width="auto" :rules="rules" ref="mapForm">
        <el-form-item label="设备编号">
          <el-input v-model="form.device_no" placeholder="设备编号"></el-input>
        </el-form-item>
        <el-form-item label="设备名称" prop="device_name">
          <el-input
            v-model="form.device_name"
            placeholder="如：大门门禁"
          ></el-input>
        </el-form-item>
        <el-form-item label="设备序列号" prop="device_id">
          <el-input
            v-model="form.device_id"
            placeholder="设备背面查看"
            :disabled="form.id"
          ></el-input>
        </el-form-item>
        <el-form-item label="设备类型" prop="device_code" required>
          <el-select v-model="form.device_code" placeholder="请选择">
            <el-option
              v-for="item in deviceCode"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备品牌" prop="brand_id" required>
          <el-select
            v-model="form.brand_id"
            placeholder="请选择"
            @change="changeBrand"
          >
            <el-option
              v-for="item in brandList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备型号" prop="model_id" required>
          <el-select v-model="form.model_id" placeholder="请选择">
            <el-option
              v-for="item in modelList"
              :key="item.id"
              :label="item.model_no"
              :value="item.id"
            >
              <div>
                <span>{{ item.model_no }}</span>
                <span style="float: right; color: #8492a6; font-size: 12px">{{
                  item.name
                }}</span>
              </div>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="链接协议"
          required
          v-if="form.device_code == 'DTU'"
        >
          <el-select v-model="form.protocol" placeholder="请选择">
            <el-option
              v-for="item in protocolType"
              :key="item.id"
              :label="item.name"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备账号" prop="device_admin" v-if="!form.id">
          <el-input
            v-model="form.device_admin"
            placeholder="设备登录账号"
          ></el-input>
        </el-form-item>
        <el-form-item label="设备密码" prop="dev_code" v-if="!form.id">
          <el-input v-model="form.dev_code" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addServiceDialog = false">取 消</el-button>
        <el-button v-if="form.id" type="primary" @click="updateForm()"
          >修 改</el-button
        >
        <el-button v-else type="primary" @click="submitForm()">添 加</el-button>
      </span>
    </el-dialog>
  </div>
</template>
  
  <script>
import { rules } from "./addRule";
import { ObjectChangedValue } from "@/js/utils";
import { deviceCode, protocolType } from "@/views/deviceManage/components/dict";
export default {
  data() {
    return {
      protocolType,
      deviceCode,
      form: {},
      temp: {},
      rules: rules,
      addServiceDialog: false,
      mechanism_id: "",
      brandList: [],
      modelList: [],
    };
  },

  mounted() {
    this.mechanism_id = this.$route.query.mecID;
    this.getBrand();
  },
  methods: {
    getBrand() {
      this.$axios({
        url: "/device/deviceBrand/queryListPage",
        params: { pageSize: 50 },
      }).then((res) => {
        this.brandList = res.data.data;
      });
    },
    changeBrand(v) {
      this.$axios({
        url: "/device/deviceModel/queryListPage",
        params: {
          brand_id: v,
          type: this.form.dev_code || null,
        },
      }).then((res) => {
        this.modelList = res.data.data;
      });
    },
    open(info) {
      if (info && info.id) {
        this.temp = Object.assign({  }, info);
        this.form = info;
      } else {
        this.form = this.temp = Object.assign({ device_admin: "admin",protocol: "MQTT" }, info);
        this.temp = {};
      }
      this.addServiceDialog = true;
    },
    updateForm() {
      this.$refs.mapForm.validate((valid) => {
        if (valid) {
          this.updateServie();
        }
      });
    },
    submitForm() {
      this.$refs.mapForm.validate((valid) => {
        if (valid) {
          this.addNew();
        }
      });
    },
    addNew() {
      let url = "/device/device/insert";
      this.form.mechanism_id = this.$route.query.mecID;
      this.$axios.post(url, this.form).then((res) => {
        this.$message({ type: "warning", message: "添加成功!" });
        this.addServiceDialog = false;
        this.form = {};
        this.$emit("success");
      });
    },
    updateServie() {
      let data = ObjectChangedValue(this.temp, this.form);
      if (Object.keys(data).length == 0) {
        this.addServiceDialog = false;
        this.form = {};
        this.temp = {};
        return;
      }
      data.id = this.form.id;
      data.device_id = this.form.device_id;
      let url = "/device/device/update";
      this.$axios.post(url, data).then((res) => {
        this.$message({ type: "success", message: "修改成功!" });
        this.addServiceDialog = false;
        this.form = {};
        this.temp = {};
        this.$emit("success");
      });
    },
  },
};
</script>
  
  <style lang="scss" scoped>
</style>